module.exports = __webpack_public_path__ + "img/edge.6f78c723.svg";